export default __webpack_public_path__ + "static/media/frog-9.2a5fa276.png";